import { ReportService, type ReportDO } from "./report.service"

export class ReportEmbed extends HTMLElement {
    private readonly slug: string = document.body.getAttribute("slug") ?? ""
    private readonly language: string | null = this.getAttribute("language")

    constructor(private reportService: ReportService = window.tbwServices.reportService) {
        super()
    }

    async connectedCallback() {
        if (!this.language || !this.verifyInput()) { return }
        if (window.tbwServices.authService.isAuthenticated) {
            await this.render()
        }
    }

    verifyInput() {
        return this.language === "fr" || this.language === "en" || this.language === "de"
    }

    getPDFUrl(content: import("./report.service").ReportDO): string | undefined {
        if (this.language === "en") return content.englishURL
        if (this.language === "de") return content.germanURL
        return content.frenchURL
    }

    async render() {
        this.innerHTML = '<p class="report-embed-loading">Loading...</p>'
        try {
            const content = await this.getReportUrl()
            const pdfUrl = this.getPDFUrl(content)
            if (!pdfUrl) {
                this.innerHTML = '<p class="report-embed-error">No PDF available for this language</p>'
                return
            }
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
            this.innerHTML = `
        <tbw-auth-state>
            <div slot="premium" style="width: 100%; height: 100%; display: flex; flex-direction: column;">
                <div class="report-embed" style="width: 100%; height: 100%; display: flex; flex-direction: column;">
                    ${isIOS
                        ? `<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; gap: 16px;">
                            <p style="margin: 0; font-size: 14px; color: #666;">Safari iOS ne supporte pas l'affichage intégré des PDF.</p>
                            <a href="${pdfUrl}" target="_blank" rel="noopener noreferrer" style="display: inline-block; padding: 12px 24px; background: #000; color: #fff; text-decoration: none; border-radius: 6px; font-size: 14px; font-weight: 600;">Ouvrir le PDF</a>
                           </div>`
                        : `<iframe src="${pdfUrl}" style="width: 100%; height: 100%; border: none; flex: 1;"></iframe>`
                    }
                </div>
            </div>
        </tbw-auth-state>
        `
        } catch {
            this.innerHTML = '<p class="report-embed-error">Unable to load report</p>'
        }
    }

    async getReportUrl(): Promise<ReportDO> {
        const content = await this.reportService.get(this.slug)
        return content
    }

}